import { ReactNode } from 'react'

export type AlertActionsProps = {
  children: ReactNode
}

export const AlertActions = ({ children }: AlertActionsProps) => {
  return <div className="pt-3 flex gap-3">{children}</div>
}
